<template>
  <div class="wrapper">
    <div class="top" v-if="list !='' ">
      <div class="left">
        <img @click="goSearch" src="../../assets/images/icon_searchhui.svg" alt />
        <input type="search" @keyup.13="goSearch" placeholder="请输入地址相关信息" v-model="searchinp" />
      </div>
      <div class="right" @click="goSearch">搜索</div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="list.length?'没有更多了':''"
      @load="getdata"
      :immediate-check="false"
      :offset="20" class="mid">
      <van-row class="no" v-if="finished&&list.length == 0">
        <img src="./../../assets/images/icon_wu.png" alt />
        <van-col>目前还没有地址信息</van-col>
      </van-row>
      <van-row
        class="box"
        v-for="(item,index) in list"
        :key="index"
        @click.native.stop="click(index)"
      >
        <van-row class="left">
          <van-row class="namebox">
            <van-row class="name">{{item.contacts}}</van-row>
            <van-row class="phone">{{item.phone_no}}</van-row>
            <van-row
              class="select"
              v-if="item.is_default=='1'"
              @click.native="setdefault(item.is_default,item.nbr)"
            >默认</van-row>
          </van-row>
          <van-row class="address">{{(item.province||"")+(item.city||"")+(item.district||"")+(item.address||"")}}</van-row>
        </van-row>
        <van-row class="right">
          <!-- <van-row class="right" type="flex" align="center" @click.native.stop="del(item.nbr)">
              <img src="./../../assets/images/icon_delete.svg" alt="">删除
          </van-row>-->
          <van-row class="text" type="flex" align="center" @click.native.stop="edit(item.nbr)">编辑</van-row>
        </van-row>
      </van-row>
    </van-list>
    <van-row @click.native.stop="edit()" class="bottom" type="flex" justify="center" align="center">添加地址</van-row>
    <!--取消订单-->
    <van-popup v-model="show" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确定要删除收货地址吗？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="show=false">取消</van-col>
          <van-col class="confirm" @click.native="confirm">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
import { handleText } from "./../../assets/js/tool";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      delid: "",
      list: [],
      show: false,
      address: "",
      searchinp: "",
      searchValue:'',
      loading:false,
      finished:false,
      pageIndex:0,
      numPerPage:10,
    };
  },
  watch: {},
  methods: {
    goSearch() {
      this.searchValue = this.searchinp
      this.list = []
      this.pageIndex=0;
      this.getdata();
    },
    /**
     * 点击切换地址 将地址存在vuex中
     */
    click(index) {
      const that = this;
      if (!that.address) {
        return;
      }
      let obj = that.list[index]
      that.$store.commit("SENDselectaddress", obj);
      this.$router.go(-1);
    },
    confirm() {
      this.show = false;
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_10011",
          nbr: this.delid,
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          this.$toast({
            message: "删除成功！",
            duration: 2000
          });
          this.delid = "";
          this.getdata();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    setdefault(is_default, nbr) {
      if (is_default == "1") {
        return false;
      }

      let toast = this.$toast.loading({
        mask: true,
        duration: 0
      });

      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_10006",
          nbr: nbr,
          uid: this.userInfo.nbr
        }
      })
        .then(response => {
          toast.clear();
          this.$toast({
            message: "设置成功！",
            duration: 2000
          });
          this.getdata();
        })
        .catch(err => {
          toast.clear();
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    edit(nbr) {
      let obj = {};
      // if(this.$route.query.show){
      //   obj.show = true
      // }
      if(nbr){
        obj.nbr = nbr
      }
      obj.supNbr = this.userInfo.nbr
      this.$router.push({ path: "/addaddress", query: obj });
    },
    del(nbr) {
      this.delid = nbr;
      this.show = true;
    },
    getdata() {
      if(this.searchValue != this.searchinp){
        this.searchinp= this.searchValue
      }
      this.loading = true;
      this.$commonPost({
        jydm: "flow_10008",
        flow_10008: {
          user_nbr: this.userInfo.nbr,
          search: this.searchValue,
          page_index: this.pageIndex * this.numPerPage,
          numPerPage: this.numPerPage
        }
      })
        .then(response => {
          let arr = [];
          if(response.addressList){
            if (response.addressList["address"].length > 0) {
            arr = response.addressList["address"];
            } else {
              arr.push(response.addressList["address"]);
            }
          }
          arr.map(item=>{item.address=handleText(item.address)})
          this.list = this.list.concat(arr);
          this.loading = false;
          if(arr.length<this.numPerPage){
            this.finished = true;
          }else{
            this.finished = false;
            this.pageIndex += 1;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    initPage(){
      if (this.$route.query.address) {
        this.address = this.$route.query.address;
      }
      this.getdata();
      let option = {
        title: '有米@'+this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
    }
  },
  created() {
    document.title = "地址管理";
    this.initPage()
  },
  mounted() {
    
  }
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
.wrapper {
  padding-top: 0.96rem;
  width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 1.82rem;
  box-sizing: border-box;
}
.top {
  position: fixed;
  top: 0;
  height: 0.88rem;
  width: 100%;
  background: #fff;
  font-size: 0.3rem;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 0.2rem solid #f5f5f5;
  .left {
    background: #f9f9f9;
    border-radius: 0.44rem;
    padding: 0.1rem 0.12rem;
    width: 6.3rem;
    height: 0.6rem;
    box-sizing: border-box;
  }
  .right {
    padding-left: 0.16rem;
    font-size: 0.28rem;
  }
  input {
    border: none;
    background: transparent;
    font-size: 0.28rem;
    width: 5.5rem;
  }
  input[type="search"]::-ms-clear {
    display: none;
  }
  input::-webkit-search-cancel-button {
    display: none;
  }
  input::-webkit-input-placeholder {
    color: #bbb;
  }
  input::-ms-input-placeholder {
    color: #bbb;
  }
  img {
    width: 0.44rem;
    height: 0.44rem;
  }
}
.bottom {
  position: fixed;
  bottom: 0.4rem;
  height: 0.8rem;
  width: 6.36rem;
  background: #E52B25;
  font-size: 0.3rem;
  color: #fff;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 0.44rem;
  img {
    width: 0.44rem;
    height: 0.44rem;
  }
}

.no {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1.96rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  img {
    width: 2.8rem;
    height: 2.8rem;
    margin-bottom: 0.1rem;
  }
  :nth-child(2) {
    font-size: 0.28rem;
    color: #999999;
  }
}

.box:after {
  display: none;
}

.mid {
  padding-top: 0.2rem;
}

.box {
  height: 1.82rem;
  box-sizing: border-box;
  display: flex;
  font-size: 0.32rem;
  color: #333333;
  background: #ffffff;
  box-shadow: 0 0.12rem 0.24rem 0 rgba(242, 242, 242, 0.5);
  line-height: 0.44rem;
  padding: 0 0.24rem;
  .left {
    width: 5.68rem;
    margin-right: 0.38rem;
    .namebox {
      display: flex;
      align-items: center;
      height: 0.4rem;
      margin-top: 0.34rem;
      .name {
        font-weight: bold;
        font-size: 0.28rem;
        color: #333333;
        word-break: break-all;
      }
      .phone {
        font-weight: bold;
        font-size: 0.28rem;
        color: #333333;
        word-break: break-all;
        margin-left: 0.8rem;
      }
    }
    .address {
      word-break: break-all;
      font-size: 0.24rem;
      color: #333333;
      margin-top: 0.12rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .select {
      font-size: 0.2rem;
      font-size: 0.2rem;
      color: #ffffff;
      background: #E52B25;
      border-radius: 0.04rem;
      width: 0.6rem;
      height: 0.3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 0.18rem;
    }
  }
  .right {
    font-size: 0.24rem;
    width: 1.18rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .text{
    border-left: 1px solid #DEDEDE;
    height: 0.6rem;
    padding-left: 0.38rem;
    }
    img {
      width: 0.4rem;
      height: 0.4rem;
    }
  }
}

/*取消订单*/
.van-popup {
  border-radius: 0.4rem;
}

.popup {
  width: 5.18rem;
  height: 2.56rem;
  .content {
    height: 1.6rem;
    text-align: center;
    font-size: 0.28rem;
    color: #333;
  }
  .cancel {
    height: 0.96rem;
    text-align: center;
    line-height: 0.96rem;
    width: 50%;
    background: #f5f5f5;
    font-size: 0.32rem;
    color: #333333;
    border-right: 1px solid #ebebeb;
  }
  .confirm {
    height: 0.96rem;
    text-align: center;
    line-height: 0.96rem;
    width: 50%;
    background: #f5f5f5;
    font-size: 0.32rem;
    color: #E52B25;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/addresslist.vue